<template>
   
      <v-flex xs12 md12>
        <v-dialog v-model="dialog" width="1000" hegiht="auto">
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md12
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
               Create New Quiz
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
             <Form
              :Item="item"
              :Field="inputFields"
              :Value="valueObj"
              @emitted="submitExam"
              />


          </v-card>
        </v-dialog>
        <material-card
        
          color="green"
          title="Quiz List"
          text=""
        >

          <v-data-table
            :headers="headers"
            :items="examList"
            
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.exam_name }}</td>
              <td>{{ item.duration }}</td>
              <td>{{ item.total_mark }}</td>
              <td>{{ item.positive_mark }}</td>
              <td>{{ item.negative_mark }}</td>
              <td>{{ item.status }}</td>
              <td>
                &nbsp;
            <!-- <v-btn color="success" dark>
               Edit
            </v-btn> -->
            </td>
            </template>
          </v-data-table>
        </material-card>
            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>{{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormLecture from '@/views/FormLecture'
import FormScript from '@/views/FormScript'
import Form from '@/views/Form'
export default {
    metaInfo () {
    return {
      title: 'Chapter Details | Admin'
    }
  },
  components: {
    Form,
    FormLecture,
    FormScript
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('lectures', ['examList']),
  },
  mounted () {
      this.getExamListByChapter(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      
    headers: [
      {
        sortable: true,
        text: 'Quiz name',
        value: 'exam_name'
      },
      {
        sortable: true,
        text: 'Duration',
        value: 'duration'
      },
      {
        sortable: true,
        text: 'Marks',
        value: 'total_mark'
      },
      {
        sortable: true,
        text: 'Positive Mark',
        value: 'positive_mark'
      },
      {
        sortable: true,
        text: 'Negative Mark',
        value: 'negative_mark'
      },
      {
        sortable: true,
        text: 'Status',
        value: 'status'
      },
      {
        sortable: false,
        text: 'Action',
        value: ''
      },
    ],
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Create new Quiz',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: {
        'chapter_id' : this.$route.params.id,
        'course_id' : this.$route.params.courseId,
        'subject_id' : this.$route.params.subjectId
       },
       
      inputFields: [
        {
          label: 'Quiz Name',
          type: 'text',
          isEnable: true,
          name: 'exam_name',
          formName: 'Exam name',
          nameRules: [
            v => !!v || 'Quiz name is required',
            v => (v && v.length <= 150) || 'Quiz name must be less than 150 characters'
          ]
        },
        {
          label: 'Duration',
          type: 'number',
          isEnable: true,
          name: 'duration',
          formName: 'duration',
           nameRules: [
            v => !!v || 'Duration is required',
          ]
        },
        {
          label: 'Total mark',
          type: 'number',
          isEnable: true,
          name: 'total_mark',
          formName: 'Total mark',
           nameRules: [
            v => !!v || 'Total mark is required',
          ]
        },
        {
          label: 'Number of questions',
          type: 'number',
          isEnable: true,
          name: 'question_number',
          formName: 'Question number',
           nameRules: [
            v => !!v || 'Question number is required',
          ]
        },
        {
          label: 'Positive mark',
          type: 'number',
          isEnable: true,
          name: 'positive_mark',
          formName: 'Positive mark',
           nameRules: []
        },
        {
          label: 'Negative mark',
          type: 'number',
          isEnable: true,
          name: 'negative_mark',
          formName: 'Negative mark',
           nameRules: []
        }
      ]
    }
  },
  created () {
  },

  methods: {
    ...mapActions("lectures", ["getExamListByChapter", "storeChapterExam"]),
 
    submitExam (data) {
      data.status = "unpublished"
      this.storeChapterExam(data).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
        this.getExamListByChapter(this.$route.params.id)
          this.dialog = false
          this.color = "success";
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }


      this.snackbar = true
    }
  }
}
</script>
